<template>
    <div class="list">
      <div class="breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item>老师管理</Breadcrumb-item>
          <Breadcrumb-item>工资条管理</Breadcrumb-item>
        </Breadcrumb>
      </div>
      <div class="search" @keyup.enter="search">
        <Form :label-width="100" :show-message="false" label-position="right">
          <Row>
            <Col :span="6">
              <Form-item label="年月">
                <Date-picker
                  type="datetime"
                  format="yyyy-MM"
                  @on-change="changeMonth"
                  v-model="myMonth"
                  placeholder="选择年月">
                </Date-picker>
              </Form-item>
            </Col>
            <Col :span="6">
              <Form-item label="ID">
                <Input name="id" v-model="queryParam.id"></Input>
              </Form-item>
            </Col>
            <Col :span="6">
              <Form-item label="老师ID">
                <Input name="tchId"
                       v-model="queryParam.tchId"></Input>
              </Form-item>
            </Col>
            <Col :span="6">
              <Form-item label="老师姓名">
                <Input placeholder="支持模糊搜索" name="tchName"
                       v-model="queryParam.tchName"></Input>
              </Form-item>
            </Col>
            <Col :span="6">
              <Form-item label="版本">
                <Input placeholder="支持模糊搜索" name="contractVersion"
                       v-model="queryParam.contractVersion"></Input>
              </Form-item>
            </Col>
            <Col :span="6">
              <Form-item label="老师类型">
                <Select v-model="queryParam.tchType" clearable @on-change="search">
                  <Option value="">All</Option>
                  <Option value="part time">part time</Option>
                  <Option value="full time">full time</Option>
                </Select>
              </Form-item>
            </Col>
            <Col :span="6">
            <Form-item label="是否确认" :label-width="100">
              <Select v-model="queryParam.confirm" clearable @on-change="search">
                <Option v-for="item in $constant.confirm" :key="item.code" :value="item.code">{{item.text}}</Option>
              </Select>
            </Form-item>
            </Col>
            <Col :span="6">
              <Form-item>
                <Row>
                <Button type="primary" :loading="searchLoading" icon="search"
                        @click="search" >搜索</Button>
                </Row>
              </Form-item>
            </Col>
          </Row>
        </Form>
      </div>
      <div class="btn-wrap">
        <el-upload
          class="upload-demo"
          :action="action"
          :on-change="handleChange"
          :headers="headers"
          :on-success="handleSuccess"
          :on-progress="handleProgress"
          :before-upload="beforeUpload"
          accept=".xls,.xlsx"
          :limit="2"
          multiple
          :show-file-list="false"
          :file-list="fileList">
          <Button type="primary"><i class="el-icon-upload el-icon--left"></i>上传</Button>
        </el-upload>
        <Button type="primary" :loading="exportLoading" @click="downTchWagesMobal">下载模板</Button>
      </div>
      <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/tchWages/list"
            :params="queryParam" :onLoading="onLoading"></List>
    </div>
</template>

<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

  export default {
    name: 'TchWagesList',
    data () {
      let $constant = this.$constant
      return {
        queryParam: {
          yearMonth: '',
          id: null,
          tchId: null,
          tchName: '',
          contractVersion: '',
          tchType: '',
          month: null,
          confirm: '',
        },
        myMonth: null,
        searchLoading: false,
        headers: {},
        reload: 0,
        rankScoreSeq: 0,
        fileList: [],
        title: [
          {
            title: 'ID',
            key: 'id',
            width: 75,
            align: 'center',
          },
          {
            title: '年月',
            key: 'yearMonth',
            width: 85,
            align: 'center',
          },
          {
            title: '是否确认',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let regType = params.row.confirm
              let canalEnum = $constant.getEnum($constant.confirm, regType)
              return h('div', canalEnum && canalEnum.text)
            }
          },
          {
            title: '老师ID-姓名',
            width: 180,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + '-' + row.tchName,
                score: row.monthRankScore
              })
            }
          },
          {
            title: '时薪',
            key: 'hourlyPay',
            width: 80,
            align: 'center',
          },
          {
            title: '老师状态',
            width: 100,
            align: 'center',
            key: 'tchCategory',
            render: (h, params) => {
              let row = params.row
              let cons = this.$constant.getEnum(this.$constant.teacherCategory, row.tchCategory)
              return h('span', cons && cons.text)
            }
          },
          {
            title: '每课薪资',
            key: 'partTimePayRate',
            width: 100,
            align: 'center',
          },
          {
            title: '异常请假率',
            key: 'abnormalLeaveRate',
            width: 120,
            align: 'center',
            render: (h, params) => {
              let abnormalLeaveRate = params.row.abnormalLeaveRate
              return h('span', abnormalLeaveRate + '%')
            }
          },
          {
            title: '实际每课薪资',
            key: 'actualPartTimePayRate',
            width: 150,
            align: 'center',
          },
          {
            title: '贝宝账号',
            key: 'paypalEmail',
            width: 250,
            align: 'center',
          },
          {
            title: '绩效奖金',
            key: 'kpi',
            width: 100,
            align: 'center',
          },
          {
            title: '上课数',
            key: 'partOrOverTimeClasses',
            width: 80,
            align: 'center',
          },
          {
            title: '两小时内学生请假数',
            key: 'inTwoHoursLeave',
            width: 200,
            align: 'center',
          },
          {
            title: '新签学生奖金',
            key: 'signUpBonus',
            width: 150,
            align: 'center',
          },
          {
            title: '推荐老师奖',
            key: 'referenceBonus',
            width: 120,
            align: 'center',
          },
          {
            title: '临时请假数',
            key: 'emergencyCount',
            width: 120,
            align: 'center',
          },
          {
            title: '取消课数',
            key: 'cancellationClasses',
            width: 120,
            align: 'center',
          },
          {
            title: '旷课数',
            key: 'absentClasses',
            width: 120,
            align: 'center',
          },
          {
            title: '老师失联数',
            key: 'ncnsClasses',
            width: 120,
            align: 'center',
          },
          {
            title: '迟到/早退',
            key: 'lateOrLeaveEarlyClasses',
            width: 120,
            align: 'center',
          },
          {
            title: '差评投诉',
            key: 'negativeFeedbackClasses',
            width: 120,
            align: 'center',
          },
          {
            title: '未评价',
            key: 'noReviewClasses',
            width: 120,
            align: 'center',
          },
          {
            title: '评价超时',
            key: 'reviewSubmittedLateClasses',
            width: 120,
            align: 'center',
          },
          {
            title: '退费学生',
            key: 'studentsRefundClasses',
            width: 120,
            align: 'center',
          },
          {
            title: '附加',
            key: 'additional',
            width: 120,
            align: 'center',
          },
          {
            title: '合计',
            key: 'total',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.total.toFixed(3))
            }
          },
          {
            title: '手续费',
            key: 'transactionFee',
            width: 80,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.transactionFee.toFixed(3))
            }
          },
          {
            title: '实付',
            key: 'totalSentSalary',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('span', row.totalSentSalary.toFixed(2))
            }
          },
          {
            title: '操作',
            fixed: 'right',
            width: 80,
            render: (h, params) => {
              let row = params.row
              return h('span', [
                h('a', {on: {click: () => this.delTchWages(row.id)}}, '删除'),
              ])
            }
          }
        ],
        exportLoading: false,
        action: this.$appConfig.baseUrl + '/tchWages/importExe'
      }
    },
    mounted: function () {
      this.init()
    },
    created: function () {
      this.init()
    },
    methods: {
      init () {
        let self = this
        let query = self.$route.query
        if (query) {
          if (query.month) {
            this.myMonth = query.month
          }
          if (query.id) {
            self.queryParam.id = query.id
          }
          if (query.tchId) {
            self.queryParam.tchId = query.tchId
          }
          if (query.tchName) {
            self.queryParam.tchName = query.tchName
          }
          if (query.contractVersion) {
            self.queryParam.contractVersion = query.contractVersion
          }
          if (query.tchType) {
            self.queryParam.tchType = query.tchType
          }
        }
      },
      search () {
        this.reload = new Date().getTime()
      },
            onLoading (loading) {
        this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },
      changeMonth (val) {
        if (val) {
          this.queryParam.month = val
          let date = new Date(val)
          let month = date.getMonth() + 1
          if (month < 10) {
            month = '0' + month
          }
          this.queryParam.yearMonth = date.getFullYear() + '' + month
        } else {
          this.queryParam.month = null
          this.queryParam.yearMonth = ''
        }
      },
      handleChange (file, fileList) {
        this.fileList = fileList.slice(-1)
      },
      beforeUpload (file) {
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }
        this.$Message.loading('服务器正在处理中...', 0)
        return true
      },
      handleProgress (event, file, fileList) {
        if (event.percent === 100) {
          event.percent = 99
        }
      },
      delTchWages (id) {
        let self = this
        if (id) {
          self.$http.post('/tchWages/delTchWages?id=' + id).then(function (res) {
            if (res.data) {
              self.search()
            }
          })
        }
      },
      handleSuccess (res, file, fileList) {
        this.$Message.success('上传成功')
        this.fileList = []
        this.search()
      },
      downTchWagesMobal () {
        let self = this
        self.exportLoading = true
        self.$http.get('/tchWages/downLoadTchWagesModal', {responseType: 'arraybuffer'}).then(function (res) {
          let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '老师工资条模板.xls'
          link.click()
          self.exportLoading = false
        }).catch((e) => {
          self.exportLoading = false
        })
      }
    }
  }
</script>


<style lang="less" scoped>
  .upload-demo {
    height: 30px;
    margin-right: 16px;
  }
  .btn-wrap {
    display: flex;
    justify-content: end;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>


// WEBPACK FOOTER //
// TchWagesList.vue?272b8940